import { render } from "./ModelPage.vue?vue&type=template&id=6f1d4ba2"
import script from "./ModelPage.vue?vue&type=script&lang=js"
export * from "./ModelPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__